import { Wealthlane_Shared_Hosting_Enums_TenantScope } from '@wealthlane/api-services/wealthlane-customer-service';

export type TenantScope = Wealthlane_Shared_Hosting_Enums_TenantScope;

/** Company-level scope (0). */
export const COMPANY_TENANT_SCOPE = Wealthlane_Shared_Hosting_Enums_TenantScope._0;

/** Instance-level scope (1). */
export const INSTANCE_TENANT_SCOPE = Wealthlane_Shared_Hosting_Enums_TenantScope._1;

/** Default tenant scope: Company (0). */
export const DEFAULT_TENANT_SCOPE = COMPANY_TENANT_SCOPE;

export const resolveTenantScope = (scope?: TenantScope): TenantScope =>
  scope ?? DEFAULT_TENANT_SCOPE;
